import { useParams } from "react-router-dom";
import { Box } from "@mui/material";

import { usePaymentLinkData } from "../../../api/queries/paymentLinks/paymentLinksQueries";

import PaymentLinkNavBar from "../PaymentLinkNavBar";

import PaymentSummary from "./PaymentSummary/PaymentSummary";
import PaymentLinkForm from "./PaymentSummary/PaymentLinkForm";

const PaymentLink = () => {
  const { linkId } = useParams();

  const { paymentLinkData, isPaymentLinkDataLoading, isPaymentLinkDataHasError } = usePaymentLinkData({ linkId });

  if (!paymentLinkData || isPaymentLinkDataLoading || isPaymentLinkDataHasError) return null;

  return (
    <Box>
      <PaymentLinkNavBar />
      <Box sx={{ display: "flex", height: "calc(100vh - 80.93px)" }}>
        <PaymentSummary paymentLink={paymentLinkData} />
        <PaymentLinkForm fields={paymentLinkData.registerFormFields} link={paymentLinkData.url} />
      </Box>
    </Box>
  );
};

export default PaymentLink;
